if (!window.__mcubeInspirationGalleryLoaded) {
window.__mcubeInspirationGalleryLoaded = true;
document.addEventListener("DOMContentLoaded", function () {
  
  // ==========================================
  // 0. CRITICAL: MOVE LIGHTBOX TO BODY
  // ==========================================
  // This physically moves the lightbox element out of the section
  // and appends it to the <body> tag. This ensures no parent container
  // (like the gallery section or sticky header) can trap its z-index.
  const globalLightbox = document.getElementById("custom-lightbox");
  if (globalLightbox) {
    document.body.appendChild(globalLightbox);
  }

  // ==========================================
  // 0.1 GALLERY PAGINATION CONFIGURATION
  // ==========================================
  const gallerySection = document.querySelector('.inspiration-gallery-metaobjects');
  let isLoggedIn = true;
  let teaserLimit = 40;
  let scrollObserver = null;

  if (gallerySection) {
    isLoggedIn = gallerySection.dataset.isLoggedIn !== 'false';
    teaserLimit = parseInt(gallerySection.dataset.teaserLimit, 10) || 40;
  }

  // ==========================================
  // INITIALIZATIONS
  // ==========================================
  const galleryGrid = document.getElementById("MainGalleryGrid");
  const roomButtons = document.querySelectorAll(".filter-btn");
  const categoryCheckboxes = document.querySelectorAll('#category-dropdown input[data-category]');
  const dropdownButton = document.getElementById("category-select");
  const dropdownContainer = document.getElementById("category-dropdown");
  const searchInput = document.getElementById("inspiration-search-input");
  const searchClear = document.getElementById("inspiration-search-clear");
  const searchStatus = document.getElementById("inspiration-search-status");
  const searchEmpty = document.getElementById("InspirationSearchEmpty");
  const initialUrlParams = new URLSearchParams(window.location.search);
  
  let currentRoom = "all";
  let selectedCategories = [];
  let currentSearch = "";
  let currentSearchInput = "";
  let currentSourceCollection = "";
  let currentSourceCollectionHandle = "";
  let isFetching = false;
  let isRestoringGallery = false;
  let activeLightboxGalleryItem = null;

  const galleryStateKey = "mcube:inspiration-gallery:state:v1";
  const galleryStateVersion = 2;
  const galleryStateMaxAge = 6 * 60 * 60 * 1000;
  const shouldRestoreGalleryState = isHistoryNavigation();
  let galleryVisitSeed = createGalleryVisitSeed();

  if (galleryGrid && initialUrlParams.get("source_collection")) {
    galleryGrid.classList.add("gallery-grid--pending-priority");
  }
  
  // Cache gallery items for faster filter operations - avoid repeated DOM queries
  let cachedGalleryItems = [];
  
  function updateCachedItems() {
    cachedGalleryItems = galleryGrid
      ? Array.from(galleryGrid.children).filter(item => item.classList.contains("gallery-item"))
      : [];
  }

  function createGalleryVisitSeed() {
    try {
      if (window.crypto?.getRandomValues) {
        const seed = new Uint32Array(1);
        window.crypto.getRandomValues(seed);
        return seed[0];
      }
    } catch (err) {
      // Fall through when secure randomness is unavailable.
    }

    return (Date.now() ^ Math.floor(Math.random() * 0xFFFFFFFF)) >>> 0;
  }

  function isHistoryNavigation() {
    const navigationEntry = window.performance?.getEntriesByType?.("navigation")?.[0];
    if (navigationEntry) return navigationEntry.type === "back_forward";

    return window.performance?.navigation?.type === 2;
  }

  function hashShuffleKey(value) {
    let hash = (galleryVisitSeed ^ 2166136261) >>> 0;
    const input = String(value || "1");

    for (let index = 0; index < input.length; index += 1) {
      hash ^= input.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }

    return hash >>> 0;
  }

  function createSeededRandom(seed) {
    let state = seed >>> 0;

    return function seededRandom() {
      state += 0x6D2B79F5;
      let value = state;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
  }

  function getGalleryPageKey(url = window.location.href) {
    try {
      return new URL(url, window.location.origin).searchParams.get("page") || "1";
    } catch (err) {
      return "1";
    }
  }

  function shuffleGalleryBatch(items, pageKey, startIndex) {
    const shuffledItems = Array.from(items);
    const random = createSeededRandom(hashShuffleKey(pageKey));

    for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(random() * (index + 1));
      [shuffledItems[index], shuffledItems[swapIndex]] = [shuffledItems[swapIndex], shuffledItems[index]];
    }

    shuffledItems.forEach((item, index) => {
      const shuffleIndex = startIndex + index;
      item.dataset.shuffleIndex = shuffleIndex;
      item._shuffleIndex = shuffleIndex;
    });

    return shuffledItems;
  }

  function normalizeSearchValue(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/&quot;/g, '"')
      .replace(/[\-_]+/g, ' ')
      .replace(/[^\w\s]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeCategoryToken(value) {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function getSearchTerms(value) {
    return normalizeSearchValue(value).split(" ").filter(Boolean);
  }

  // ==========================================
  // URL STATE MANAGEMENT
  // ==========================================
  
  /**
   * Build URL query string from current filter state
   * Returns clean URL with encoded parameters
   */
  function buildFilterQueryString() {
    const params = new URLSearchParams();
    
    // Add room filter (skip if "all")
    if (currentRoom && currentRoom !== "all") {
      params.set("room", currentRoom);
    }
    
    // Add category filters (comma-separated)
    if (selectedCategories.length > 0) {
      params.set("categories", selectedCategories.join(","));
    }

    if (currentSearch) {
      params.set("q", currentSearch);
    }

    if (currentSourceCollection) {
      params.set("source_collection", currentSourceCollection);
    }
    
    return params.toString();
  }
  
  /**
   * Update browser URL with current filter state (no page reload)
   * Uses history.replaceState to maintain clean history
   */
  function updateUrlWithFilters() {
    try {
      const queryString = buildFilterQueryString();
      const newUrl = queryString 
        ? `${window.location.pathname}?${queryString}` 
        : window.location.pathname;
      
      window.history.replaceState(null, "", newUrl);
    } catch (err) {
      // Fail silently - some browsers may have restrictions
      console.warn("URL update not available:", err);
    }
  }
  
  /**
   * Extract filter state from current URL query parameters
   * Returns object with room and categories
   */
  function getFilterStateFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const room = params.get("room") || "all";
      const categoriesStr = params.get("categories") || "";
      const search = normalizeSearchValue(params.get("q") || "");
      const sourceCollectionRaw = params.get("source_collection") || "";
      const sourceCollection = normalizeSearchValue(sourceCollectionRaw);
      const categories = categoriesStr 
        ? categoriesStr.split(",").filter(c => c.trim()) 
        : [];
      
      return { room, categories, search, sourceCollection, sourceCollectionRaw };
    } catch (err) {
      // Fail silently on parse errors
      console.warn("URL parse error:", err);
      return { room: "all", categories: [], search: "", sourceCollection: "", sourceCollectionRaw: "" };
    }
  }
  
  /**
   * Restore filter state from URL on page load
   * Applies filters without triggering URL update (avoids recursion)
   */
  function restoreFilterStateFromUrl() {
    const { room, categories, search, sourceCollection, sourceCollectionRaw } = getFilterStateFromUrl();
    
    try {
      // Restore room filter
      currentRoom = room;
      
      // Update room button UI
      roomButtons.forEach(btn => {
        btn.classList.remove("active");
        if (btn.dataset.room === room) {
          btn.classList.add("active");
        }
      });
      
      // Restore category filters
      selectedCategories = categories;
      currentSearch = search;
      currentSearchInput = search;
      currentSourceCollection = sourceCollection;
      currentSourceCollectionHandle = normalizeSearchValue((sourceCollectionRaw || "").replace(/-/g, " "));
      
      // Update category checkbox UI
      categoryCheckboxes.forEach(cb => {
        const cbValue = cb.value || "";
        
        if (cbValue === "") {
          // "All" checkbox
          cb.checked = categories.length === 0;
        } else {
          // Specific category checkbox
          cb.checked = categories.includes(cbValue);
        }
      });
      
      // Update dropdown text
      updateDropdownText();
      updateSearchUi();
      
      // Apply immediately so restoration and browser history see stable ordering.
      applyFiltersNow();
      
    } catch (err) {
      // Fail silently on restore errors
      console.warn("Filter restore error:", err);
    }
  }
  
  /**
   * Handle browser back/forward navigation
   * Re-reads URL and reapplies filters
   */
  function setupPopstateListener() {
    window.addEventListener("popstate", function() {
      restoreFilterStateFromUrl();
    });
  }

  // ==========================================
  // 1. INFINITE SCROLL LOGIC
  // ==========================================
  const initInfiniteScroll = () => {
    const sentinel = document.querySelector(".infinite-scroll-sentinel");
    if (!sentinel) return;

    if (scrollObserver) {
      scrollObserver.disconnect();
    }

    const observerRootMargin = currentSourceCollection ? "1600px" : "600px";

    scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isFetching) {
          loadNextPage(entry.target);
        }
      });
    }, { rootMargin: observerRootMargin });

    scrollObserver.observe(sentinel);
  };

  // Legacy login gate helper kept as a no-op fallback
  function showLoginGateOverlay() {
    const overlay = document.getElementById('loginGateOverlay');
    if (overlay) {
      overlay.style.display = 'block';
      // Add fade-in animation
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.5s ease';
      requestAnimationFrame(() => {
        overlay.style.opacity = '1';
      });
    }
  }

  // Legacy login gate helper kept as a no-op fallback
  function hideLoginGateOverlay() {
    const overlay = document.getElementById('loginGateOverlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  }

  async function loadNextPage(sentinel, options = {}) {
    const shouldReobserve = options.reobserve !== false;
    const nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl) return false;

    isFetching = true;
    if (scrollObserver) {
      scrollObserver.unobserve(sentinel);
    }
    
    try {
      const response = await fetch(nextUrl, { cache: "no-store" });
      if (!response.ok) {
        throw new Error("Failed to fetch next inspiration gallery page");
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find new items
      const newItems = Array.from(doc.querySelectorAll(".gallery-item"));
      const newSentinel = doc.querySelector(".infinite-scroll-sentinel");

      // Append new items to grid - batch DOM operations for performance
      const fragment = document.createDocumentFragment();
      const startIndex = cachedGalleryItems.length;
      newItems.forEach((item, index) => {
        item.dataset.originalIndex = startIndex + index;
        // Preprocess categories once (avoid expensive string ops on every filter change)
        preprocessItemCategories(item);
      });

      const shuffledNewItems = shuffleGalleryBatch(newItems, getGalleryPageKey(nextUrl), startIndex);
      shuffledNewItems.forEach(item => {
        // Apply filters after item is in DOM (not before)
        applyFiltersToSingleItem(item);
        
        // Attach observers to new elements BEFORE adding to DOM
        lazyObserver.observe(item);
        const v = item.querySelector('video');
        if(v) videoObserver.observe(v);
        
        // Add to fragment instead of directly to DOM
        fragment.appendChild(item);
      });
      
      // Insert all new items at once (single DOM reflow)
      galleryGrid.insertBefore(fragment, sentinel);
      
      // Update cached items list
      updateCachedItems();

      if (currentSourceCollection || currentSearch || selectedCategories.length > 0 || currentRoom !== "all") {
        applyFilters();
      }

      // Update or remove sentinel
      if (newSentinel) {
        const newNextUrl = newSentinel.dataset.nextUrl;
        if (newNextUrl) {
          sentinel.dataset.nextUrl = newNextUrl;
          if (scrollObserver && shouldReobserve) {
            scrollObserver.observe(sentinel);
          }
          isFetching = false;
          scheduleGalleryStatePersist();
          return true;
        } else {
          sentinel.remove();
        }
      } else {
        sentinel.remove();
      }

    } catch (err) {
      console.error("Error loading more items:", err);
      if (scrollObserver && sentinel && sentinel.isConnected && shouldReobserve) {
        scrollObserver.observe(sentinel);
      }
      isFetching = false;
      return false;
    }

    isFetching = false;
    scheduleGalleryStatePersist();
    return false;
  }

  async function preloadPriorityPages() {
    const autoPreloadPages = currentSourceCollection ? 3 : 0;
    if (!autoPreloadPages || !galleryGrid) return;

    const sentinel = galleryGrid.querySelector(".infinite-scroll-sentinel");
    if (!sentinel) return;

    for (let pageIndex = 0; pageIndex < autoPreloadPages; pageIndex += 1) {
      if (!sentinel.isConnected || !sentinel.dataset.nextUrl || isFetching) break;

      const hasMorePages = await loadNextPage(sentinel, { reobserve: false });
      preloadImages();

      if (!hasMorePages) break;
    }

    applyFilters();
  }

  // ==========================================
  // 2. FILTERING LOGIC - PERFORMANCE OPTIMIZED
  // ==========================================
  
  // Preprocess item categories once and cache them
  function preprocessItemCategories(item) {
    const categories = item.dataset.categories || "";
    // Pre-process categories once, store as array on the element
    item._processedCategories = categories.split(',').map(c => 
      normalizeCategoryToken(c)
    );
    item._originalIndex = Number(item.dataset.originalIndex || 0);
    item._shuffleIndex = Number(item.dataset.shuffleIndex || item.dataset.originalIndex || 0);
    item._titleSearch = normalizeSearchValue(item.dataset.title || "");
    item._categorySearch = normalizeSearchValue(item.dataset.categories || "");
    item._styleSearch = normalizeSearchValue(item.dataset.style || "");
    item._materialSearch = normalizeSearchValue(item.dataset.materials || "");
    item._collectionSearch = normalizeSearchValue(item.dataset.collections || "");
    item._collectionHandleSearch = normalizeSearchValue((item.dataset.collectionHandles || "").replace(/\|/g, " "));
    item._productSearch = normalizeSearchValue(item.dataset.products || "");
    item._searchBlob = normalizeSearchValue([
      item.dataset.title || "",
      item.dataset.categories || "",
      item.dataset.style || "",
      item.dataset.materials || "",
      item.dataset.collections || "",
      item.dataset.products || "",
      item.dataset.search || ""
    ].join(" "));
  }

  // Initialize all existing items with preprocessed categories
  function initFilterCache() {
    updateCachedItems();
    cachedGalleryItems.forEach((item, index) => {
      item.dataset.originalIndex = index;
      preprocessItemCategories(item);
    });

    if (!galleryGrid || cachedGalleryItems.length < 2) return;

    const sentinel = galleryGrid.querySelector(".infinite-scroll-sentinel");
    const shuffledItems = shuffleGalleryBatch(cachedGalleryItems, getGalleryPageKey(), 0);
    shuffledItems.forEach(item => galleryGrid.insertBefore(item, sentinel));
    updateCachedItems();
  }

  function updateSearchUi() {
    if (searchInput) {
      searchInput.value = currentSearchInput;
    }
    if (searchClear) {
      searchClear.hidden = currentSearchInput.trim().length === 0;
    }
  }

  function updateSearchFeedback(visibleCount) {
      if (searchStatus) {
      if (currentSearch) {
        searchStatus.textContent = `${visibleCount} ${visibleCount === 1 ? "scene" : "scenes"} for "${currentSearch}"`;
      } else if (currentSourceCollection) {
        searchStatus.textContent = `${visibleCount} ${visibleCount === 1 ? "scene" : "scenes"} with ${currentSourceCollection} inspiration prioritised first`;
      } else if (selectedCategories.length > 0 || currentRoom !== "all") {
        searchStatus.textContent = `${visibleCount} ${visibleCount === 1 ? "scene" : "scenes"} visible`;
      } else {
        searchStatus.textContent = "";
      }
    }

    if (searchEmpty) {
      searchEmpty.classList.toggle("is-visible", visibleCount === 0);
    }
  }

  // Debounce function to prevent excessive filter recalculations
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function getGalleryStateUrl() {
    return `${window.location.pathname}${window.location.search}`;
  }

  function removeStoredGalleryState() {
    try {
      window.sessionStorage.removeItem(galleryStateKey);
    } catch (err) {
      // Storage can be unavailable in private or restricted browser contexts.
    }
  }

  function readStoredGalleryState() {
    try {
      if (!shouldRestoreGalleryState) {
        removeStoredGalleryState();
        return null;
      }

      const rawState = window.sessionStorage.getItem(galleryStateKey);
      if (!rawState) return null;

      const state = JSON.parse(rawState);
      const isExpired = !Number.isFinite(state.savedAt) || Date.now() - state.savedAt > galleryStateMaxAge;
      const isValid = state.version === galleryStateVersion
        && state.url === getGalleryStateUrl()
        && Number.isFinite(state.loadedItemCount)
        && state.loadedItemCount > 0
        && Number.isFinite(state.shuffleSeed)
        && !isExpired;

      if (!isValid) {
        removeStoredGalleryState();
        return null;
      }

      return state;
    } catch (err) {
      removeStoredGalleryState();
      return null;
    }
  }

  function getGalleryAnchor(preferredItem = null) {
    if (preferredItem?.isConnected && !preferredItem.classList.contains("filtered-out")) {
      return preferredItem;
    }

    let closestItem = null;
    let closestDistance = Number.POSITIVE_INFINITY;

    cachedGalleryItems.forEach(item => {
      if (item.classList.contains("filtered-out")) return;
      const rect = item.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const distance = Math.abs(rect.top);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestItem = item;
      }
    });

    return closestItem;
  }

  function persistGalleryState(preferredItem = null) {
    if (!galleryGrid || isRestoringGallery) return;

    const anchorItem = getGalleryAnchor(preferredItem);
    const sentinel = galleryGrid.querySelector(".infinite-scroll-sentinel");
    const state = {
      version: galleryStateVersion,
      savedAt: Date.now(),
      url: getGalleryStateUrl(),
      loadedItemCount: cachedGalleryItems.length,
      shuffleSeed: galleryVisitSeed,
      nextUrl: sentinel?.dataset.nextUrl || "",
      hasMorePages: Boolean(sentinel?.dataset.nextUrl),
      scrollY: Math.max(0, window.scrollY || window.pageYOffset || 0),
      anchorSceneUrl: anchorItem?.dataset.sceneUrl || "",
      anchorViewportTop: anchorItem ? anchorItem.getBoundingClientRect().top : null
    };

    try {
      window.sessionStorage.setItem(galleryStateKey, JSON.stringify(state));
    } catch (err) {
      // New-tab navigation still preserves the live gallery if storage is blocked.
    }
  }

  const scheduleGalleryStatePersist = debounce((preferredItem = null) => {
    persistGalleryState(preferredItem);
  }, 180);

  function waitForAnimationFrame() {
    return new Promise(resolve => window.requestAnimationFrame(resolve));
  }

  async function waitForAnchorLayout(anchorItem) {
    if (document.fonts?.ready) {
      try {
        await document.fonts.ready;
      } catch (err) {
        // Font readiness is an enhancement, not a restoration requirement.
      }
    }

    const image = anchorItem?.querySelector("img");
    if (image && !image.complete && typeof image.decode === "function") {
      await Promise.race([
        image.decode().catch(() => undefined),
        new Promise(resolve => window.setTimeout(resolve, 800))
      ]);
    }

    await waitForAnimationFrame();
    await waitForAnimationFrame();
  }

  async function restoreGalleryState(state) {
    if (!galleryGrid || !state) return false;

    isRestoringGallery = true;
    galleryGrid.setAttribute("aria-busy", "true");
    scrollObserver?.disconnect();

    try {
      const targetItemCount = Math.max(cachedGalleryItems.length, state.loadedItemCount);
      let restorePasses = 0;

      while (cachedGalleryItems.length < targetItemCount && restorePasses < 12) {
        const sentinel = galleryGrid.querySelector(".infinite-scroll-sentinel");
        if (!sentinel?.dataset.nextUrl || isFetching) break;

        const previousItemCount = cachedGalleryItems.length;
        await loadNextPage(sentinel, { reobserve: false });
        restorePasses += 1;

        if (cachedGalleryItems.length <= previousItemCount) break;
      }

      applyFiltersNow();

      const anchorItem = state.anchorSceneUrl
        ? cachedGalleryItems.find(item => item.dataset.sceneUrl === state.anchorSceneUrl)
        : null;

      await waitForAnchorLayout(anchorItem);

      if (anchorItem && Number.isFinite(state.anchorViewportTop)) {
        const targetScroll = Math.max(
          0,
          (window.scrollY || window.pageYOffset || 0)
            + anchorItem.getBoundingClientRect().top
            - state.anchorViewportTop
        );
        window.scrollTo({ top: targetScroll, left: 0, behavior: "auto" });
      } else if (Number.isFinite(state.scrollY)) {
        window.scrollTo({ top: Math.max(0, state.scrollY), left: 0, behavior: "auto" });
      }

      return true;
    } catch (err) {
      console.warn("Gallery state restoration was incomplete:", err);
      return false;
    } finally {
      isRestoringGallery = false;
      galleryGrid.removeAttribute("aria-busy");
      persistGalleryState();
    }
  }

  // Optimized applyFilters - uses cached items and cached category data
  function applyFiltersNow() {
    let visibleCount = 0;
    const visibleItems = [];
    const sentinel = galleryGrid ? galleryGrid.querySelector(".infinite-scroll-sentinel") : null;

    cachedGalleryItems.forEach(item => {
      const result = applyFiltersToSingleItem(item);
      if (result.visible) {
        visibleCount += 1;
        visibleItems.push({ item, score: result.score });
      }
    });

    if (galleryGrid) {
      const shouldRankResults = Boolean(currentSearch || currentSourceCollection);
      galleryGrid.classList.toggle("gallery-grid--ranked", shouldRankResults);

      const orderedItems = shouldRankResults
        ? visibleItems
            .sort((a, b) => {
              if (b.score !== a.score) return b.score - a.score;
              return a.item._shuffleIndex - b.item._shuffleIndex;
            })
            .map(({ item }) => item)
        : cachedGalleryItems.slice().sort((a, b) => a._shuffleIndex - b._shuffleIndex);

      orderedItems.forEach(item => {
        galleryGrid.insertBefore(item, sentinel);
      });

      galleryGrid.classList.remove("gallery-grid--pending-priority");
    }

    updateSearchFeedback(visibleCount);
    scheduleGalleryStatePersist();
  }

  const applyFilters = debounce(applyFiltersNow, 50);

  function calculateSearchScore(item, searchTerms) {
    if (!searchTerms.length) return { matched: true, score: 0 };

    const exactPhrase = currentSearch;
    let score = 0;
    let matchedTerms = 0;

    if (exactPhrase) {
      if (item._collectionSearch.includes(exactPhrase)) score += 260;
      if (item._categorySearch.includes(exactPhrase)) score += 220;
      if (item._titleSearch.includes(exactPhrase)) score += 180;
      if (item._productSearch.includes(exactPhrase)) score += 150;
      if (item._styleSearch.includes(exactPhrase) || item._materialSearch.includes(exactPhrase)) score += 120;
      if (item._searchBlob.includes(exactPhrase)) score += 60;
    }

    searchTerms.forEach(term => {
      let termMatched = false;

      if (item._collectionSearch.includes(term)) {
        score += 90;
        termMatched = true;
      }
      if (item._categorySearch.includes(term)) {
        score += 70;
        termMatched = true;
      }
      if (item._titleSearch.includes(term)) {
        score += 55;
        termMatched = true;
      }
      if (item._productSearch.includes(term)) {
        score += 40;
        termMatched = true;
      }
      if (item._styleSearch.includes(term) || item._materialSearch.includes(term)) {
        score += 28;
        termMatched = true;
      }
      if (!termMatched && item._searchBlob.includes(term)) {
        score += 12;
        termMatched = true;
      }

      if (termMatched) {
        matchedTerms += 1;
      }
    });

    if (matchedTerms === searchTerms.length) {
      score += 35;
    }

    return {
      matched: matchedTerms > 0 || score > 0,
      score
    };
  }

  function calculateSourceCollectionScore(item) {
    if (!currentSourceCollection) return 0;

    let score = 0;

    if (currentSourceCollectionHandle && item._collectionHandleSearch.includes(currentSourceCollectionHandle)) score += 900;
    if (item._collectionSearch.includes(currentSourceCollection)) score += 420;
    if (item._categorySearch.includes(currentSourceCollection)) score += 180;
    if (item._productSearch.includes(currentSourceCollection)) score += 120;
    if (item._titleSearch.includes(currentSourceCollection)) score += 80;
    if (item._styleSearch.includes(currentSourceCollection) || item._materialSearch.includes(currentSourceCollection)) score += 45;

    return score;
  }

  function applyFiltersToSingleItem(item) {
    const room = item.dataset.room || "";
    
    // Use preprocessed categories (cached on element)
    const itemCategories = item._processedCategories || [];
    
    const roomMatch = currentRoom === "all" || room === currentRoom;
    let categoryMatch = true;
    let searchMatch = true;
    let searchScore = calculateSourceCollectionScore(item);

    if (selectedCategories.length > 0) {
      categoryMatch = selectedCategories.some(sel => 
        itemCategories.includes(normalizeCategoryToken(sel))
      );
    }

    if (currentSearch) {
      const searchTerms = getSearchTerms(currentSearch);
      const searchResult = calculateSearchScore(item, searchTerms);
      searchMatch = searchResult.matched;
      searchScore = searchResult.score;
    }
    
    // Use CSS class instead of inline display for better performance
    // This avoids layout thrashing that occurs with style.display
    if (roomMatch && categoryMatch && searchMatch) {
      item.classList.remove('filtered-out');
      return { visible: true, score: searchScore };
    } else {
      item.classList.add('filtered-out');
      return { visible: false, score: 0 };
    }
  }

  // Event Listeners for Filters
  roomButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      roomButtons.forEach(b => b.classList.remove("active"));
      this.classList.add("active");
      currentRoom = this.dataset.room;
      applyFilters();
      updateUrlWithFilters();
    });
  });

  categoryCheckboxes.forEach(cb => {
    cb.addEventListener("change", function() {
      // Logic to handle "All" vs specific checkboxes
      if(this.value === "") {
        if(this.checked) {
           categoryCheckboxes.forEach(c => c !== this ? c.checked = false : null);
           selectedCategories = [];
        }
      } else {
          document.querySelector('input[value=""][data-category]').checked = false;
          selectedCategories = Array.from(categoryCheckboxes)
            .filter(c => c.checked && c.value !== "")
            .map(c => c.value);
      }
      applyFilters();
      updateDropdownText();
      updateUrlWithFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener("input", debounce(function(event) {
      currentSearchInput = event.target.value || "";
      currentSearch = normalizeSearchValue(currentSearchInput);
      updateSearchUi();
      applyFilters();
      updateUrlWithFilters();
    }, 120));
  }

  if (searchClear) {
    searchClear.addEventListener("click", function() {
      currentSearchInput = "";
      currentSearch = "";
      updateSearchUi();
      applyFilters();
      updateUrlWithFilters();
      if (searchInput) {
        searchInput.focus();
      }
    });
  }

  // ==========================================
  // 2.1. DROPDOWN TOGGLE FUNCTIONALITY
  // ==========================================
  function updateDropdownText() {
    if (!dropdownButton) return;
    const dropdownText = dropdownButton.querySelector('.dropdown-text');
    if (selectedCategories.length === 0) {
      dropdownText.textContent = 'All Categories';
    } else if (selectedCategories.length === 1) {
      const categoryLabel = document.querySelector(`input[data-category][value="${selectedCategories[0]}"]`)?.nextElementSibling?.textContent || selectedCategories[0];
      dropdownText.textContent = categoryLabel;
    } else {
      dropdownText.textContent = `${selectedCategories.length} Categories`;
    }
  }

  if (dropdownButton && dropdownContainer) {
    dropdownButton.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      dropdownContainer.classList.toggle("open");
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function(e) {
      if (!dropdownContainer.contains(e.target)) {
        dropdownContainer.classList.remove("open");
      }
    });

    // Close dropdown on escape key
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") {
        dropdownContainer.classList.remove("open");
      }
    });
  }

  // ==========================================
  // 3. UTILITIES & OBSERVERS
  // ==========================================
  
  // Preload only visible images (not filtered out) - runs once efficiently
  const preloadImages = () => {
    // Only preload first batch of visible items for fast initial render
    const visibleItems = cachedGalleryItems.filter(item => !item.classList.contains('filtered-out')).slice(0, 20);
    visibleItems.forEach(item => {
      const img = item.querySelector('img');
      if (img && img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
  };

  // Lazy Load Animation - optimized to skip filtered-out items
  const lazyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Skip if item is filtered out (not visible anyway)
      if (entry.target.classList.contains('filtered-out')) {
        return;
      }
      if (entry.isIntersecting) {
        entry.target.classList.remove("hidden-item");
        // Stop observing once the item is visible
        lazyObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: "300px", threshold: 0.1 });

  // Video Autoplay
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.play();
      else entry.target.pause();
    });
  }, { threshold: 0.5 });

  // Lightbox (Delegated - works for new items automatically)
  document.addEventListener("click", function(e) {
    const scenePageLink = e.target.closest(".lightbox-scene-btn");
    if (scenePageLink) {
      persistGalleryState(activeLightboxGalleryItem);
    }

    const trigger = e.target.closest(".lightbox-trigger");
    if(trigger) {
      e.preventDefault();
      openLightbox(trigger);
    }
  });

  // ==========================================
  // 4. LIGHTBOX FUNCTIONALITY
  // ==========================================
  function openLightbox(trigger) {
    // Note: We use globalLightbox (referenced via ID) so it works even after moving to body
    const lightbox = document.getElementById("custom-lightbox");
    const mediaContent = document.getElementById("custom-lightbox-content");
    const productsSidebar = document.getElementById("lb-products");
    const productsDock = document.getElementById("lb-dock");
    const productsList = document.getElementById("lb-list");
    const productsDockList = document.getElementById("lb-dock-list");
    
    if (!lightbox || !mediaContent) return;

    // Clear previous content
    mediaContent.innerHTML = "";
    productsList.innerHTML = "";
    productsDockList.innerHTML = "";
    lightbox.querySelectorAll(".lightbox-scene-cta").forEach(node => node.remove());
    lightbox.querySelectorAll(".mcube-lightbox-scene-actions").forEach(node => node.remove());

    // --- TITLE LOGIC ---
    const galleryItem = trigger.closest(".gallery-item");
    activeLightboxGalleryItem = galleryItem;
    const itemTitle = galleryItem.dataset.title || "";
    const sidebarTitle = productsSidebar.querySelector(".lb-sidebar__title");
    const dockTitle = productsDock.querySelector(".lb-dock__title");
    
    if (sidebarTitle) sidebarTitle.textContent = itemTitle;
    if (dockTitle) dockTitle.textContent = itemTitle;
    // --- END TITLE LOGIC ---

    // Get the media URL and type
    const mediaUrl = trigger.getAttribute("href");
    const mediaType = trigger.dataset.type || "image";

    // Create media element
    let mediaElement;
    if (mediaType === "video") {
      mediaElement = document.createElement("video");
      mediaElement.src = mediaUrl;
      mediaElement.controls = true;
      mediaElement.autoplay = true;
      mediaElement.loop = true;
      mediaElement.muted = true;
    } else {
      mediaElement = document.createElement("img");
      mediaElement.src = mediaUrl;
      mediaElement.alt = galleryItem.querySelector("img")?.alt || "Gallery image";
    }
    
    mediaContent.appendChild(mediaElement);

    // Get products from the gallery item
    const productsHtml = galleryItem.querySelector(".lb-products-html");
    
    if (productsHtml && productsHtml.innerHTML.trim()) {
      // Show products in both desktop sidebar and mobile dock
      productsSidebar.style.display = "block";
      productsDock.style.display = "block";
      lightbox.classList.add("has-dock");
       
      // Clone products for both sidebar and dock
      const productsContent = productsHtml.innerHTML;
      productsList.innerHTML = productsContent;
      productsDockList.innerHTML = productsContent;
    } else {
      // Hide products if none available
      productsSidebar.style.display = "none";
      productsDock.style.display = "none";
      lightbox.classList.remove("has-dock");
    }
    
    // Keep scene actions inside the focused lightbox workflow.
    addSceneSaveActions(galleryItem);
    addWhatsAppButton(galleryItem);
    addScenePageButtons(galleryItem);
    
    // Show lightbox
    lightbox.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  // ==========================================
  // 5. WHATSAPP BUTTON FUNCTIONALITY
  // ==========================================
  function addWhatsAppButton(galleryItem) {
    const lightbox = document.getElementById("custom-lightbox");
    if (!lightbox) return;

    // Remove existing buttons if any
    const existingButtons = lightbox.querySelectorAll(".whatsapp-enquiry-btn");
    existingButtons.forEach(btn => btn.remove());

    // Extract data from gallery item
    const sceneTitle = galleryItem.dataset.title || "";
    const roomType = galleryItem.dataset.room || "";
    const slug = galleryItem.dataset.slug || "";
    const displayIndex = galleryItem.dataset.displayIndex || "";
    const productCategory = galleryItem.dataset.categories || "";

    // Get product data from the hidden products HTML
    const productsHtml = galleryItem.querySelector(".lb-products-html");
    let productTitle = "";
    let productHandle = "";

    if (productsHtml && productsHtml.innerHTML.trim()) {
      const firstProductLink = productsHtml.querySelector(".lb-item__title");
      if (firstProductLink) {
        productTitle = firstProductLink.textContent || "";
        const productUrl = firstProductLink.getAttribute("href");
        if (productUrl) {
          const match = productUrl.match(/\/products\/([^\/]+)/);
          if (match && match[1]) {
            productHandle = match[1];
          }
        }
      }
    }

    // Generate scene reference
    const sceneReference = slug ? `MCUBE-SCENE-${slug}` : `MCUBE-SCENE-${displayIndex}`;

    // Build WhatsApp message
    let message = `Hi, I'm interested in this inspiration scene from M Cube Spaces.\n\n`;
    message += `Scene: ${sceneTitle}\n\n`;

    if (productTitle && productHandle) {
      const productUrl = `${window.location.origin}/products/${productHandle}`;
      message += `Product Used:\n`;
      message += `${productTitle}\n`;
      message += `${productUrl}\n\n`;
    } else if (productCategory) {
      message += `Product Category: ${productCategory}\n\n`;
    }

    message += `Please guide me on finishes, installation, and pricing.`;

    // URL encode the message
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/919967434881?text=${encodedMessage}`;

    // Create button element
    const whatsappButton = document.createElement("a");
    whatsappButton.href = whatsappUrl;
    whatsappButton.className = "whatsapp-enquiry-btn";
    whatsappButton.target = "_blank";
    whatsappButton.rel = "noopener noreferrer";
    whatsappButton.innerHTML = `
      <span class="whatsapp-icon-badge">
        <img src="https://cdn.shopify.com/s/files/1/0614/4576/7281/files/WhatsApp_svg.webp?v=1757934770" alt="WhatsApp" width="20" height="20">
      </span>
      Enquire on WhatsApp
    `;

    // Add button to the right-side lightbox panel (desktop)
    const productsSidebar = document.getElementById("lb-products");
    if (productsSidebar) {
      productsSidebar.appendChild(whatsappButton);
    }

    // Add button to the mobile dock as well
    const productsDockInner = document.querySelector("#lb-dock .lb-dock__inner");
    if (productsDockInner) {
      const dockButton = whatsappButton.cloneNode(true);
      dockButton.classList.add("whatsapp-enquiry-btn-dock");
      productsDockInner.appendChild(dockButton);
    }
   }

  function addScenePageButtons(galleryItem) {
    const sceneUrl = galleryItem?.dataset.sceneUrl || "";
    if (!sceneUrl) return;

    const sceneTitle = galleryItem?.dataset.title || "Scene";
    const createScenePageButton = () => {
      const wrapper = document.createElement("div");
      const link = document.createElement("a");

      wrapper.className = "lightbox-scene-cta";
      link.className = "lightbox-scene-btn";
      link.href = sceneUrl;
      link.target = "_blank";
      link.rel = "noopener";
      link.setAttribute("aria-label", `Open ${sceneTitle} page in a new tab`);
      link.textContent = "View Full Scene";
      wrapper.appendChild(link);

      return wrapper;
    };

    const productsSidebar = document.getElementById("lb-products");
    const productsDockInner = document.querySelector("#lb-dock .lb-dock__inner");

    if (productsSidebar) {
      productsSidebar.appendChild(createScenePageButton());
    }

    if (productsDockInner) {
      productsDockInner.appendChild(createScenePageButton());
    }
  }

  function addSceneSaveActions(galleryItem) {
    const template = galleryItem?.querySelector(".mcube-scene-actions-template");
    const source = template?.content?.querySelector(".mcube-scene-actions");
    if (!source) return;

    [document.getElementById("lb-products"), document.querySelector("#lb-dock .lb-dock__inner")]
      .filter(Boolean)
      .forEach(target => {
        const wrapper = document.createElement("div");
        wrapper.className = "mcube-lightbox-scene-actions";
        wrapper.appendChild(source.cloneNode(true));
        target.appendChild(wrapper);
      });
  }

  function closeLightbox() {
    const lightbox = document.getElementById("custom-lightbox");
    if (!lightbox) return;

    lightbox.classList.remove("active");
    document.body.style.overflow = "";
    activeLightboxGalleryItem = null;

    // --- RESET TITLE LOGIC ---
    const sidebarTitle = lightbox.querySelector(".lb-sidebar__title");
    const dockTitle = lightbox.querySelector(".lb-dock__title");
    if (sidebarTitle) sidebarTitle.textContent = "";
    if (dockTitle) dockTitle.textContent = "";
    // --- END RESET ---
    lightbox.querySelectorAll(".lightbox-scene-cta").forEach(node => node.remove());
    lightbox.querySelectorAll(".mcube-lightbox-scene-actions").forEach(node => node.remove());
    
    // Pause any playing videos
    const video = lightbox.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  }

  // Lightbox event listeners
  const closeButton = document.getElementById("custom-lightbox-close");
  if (closeButton) {
    closeButton.addEventListener("click", closeLightbox);
  }

  // Close lightbox when clicking on backdrop
  const lightbox = document.getElementById("custom-lightbox");
  if (lightbox) {
    lightbox.addEventListener("click", function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  }

  // Close lightbox with escape key
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && lightbox?.classList.contains("active")) {
      closeLightbox();
    }
  });

  // ==========================================
  // 6. BFCACHE-SAFE STATE LIFECYCLE
  // ==========================================
  window.addEventListener("scroll", () => {
    scheduleGalleryStatePersist();
  }, { passive: true });

  window.addEventListener("pagehide", () => {
    persistGalleryState(activeLightboxGalleryItem);
  });

  window.addEventListener("pageshow", event => {
    if (!event.persisted || !galleryGrid) return;
    updateCachedItems();
    galleryGrid.removeAttribute("aria-busy");
    initInfiniteScroll();
    scheduleGalleryStatePersist(activeLightboxGalleryItem);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      persistGalleryState(activeLightboxGalleryItem);
    }
  });

  // ==========================================
  // INITIALIZE
  // ==========================================
  async function initializeGallery() {
    const storedGalleryState = readStoredGalleryState();
    if (storedGalleryState) {
      galleryVisitSeed = storedGalleryState.shuffleSeed >>> 0;
    }
    isRestoringGallery = Boolean(storedGalleryState && galleryGrid);

    // Preprocess all category/search data first
    initFilterCache();
    
    // Set up URL history listener for back/forward navigation
    setupPopstateListener();
    
    // Restore filter state from URL parameters (if any)
    restoreFilterStateFromUrl();

    // Observe initial items for lazy loading before preloading extra pages
    cachedGalleryItems.forEach(item => {
      lazyObserver.observe(item);
      const v = item.querySelector('video');
      if(v) videoObserver.observe(v);
    });

    if (storedGalleryState) {
      await restoreGalleryState(storedGalleryState);
    } else {
      await preloadPriorityPages();
    }

    initInfiniteScroll();
    updateSearchUi();
    
    // Preload only visible images after cache is ready
    preloadImages();
    scheduleGalleryStatePersist();
  }

  initializeGallery();
});
}
